<template>
  <div role="radiogroup" aria-label="project-filter">
    <my-radio-button v-for="key in keys" :key="key" :color="colorMap[key]" :checked="current === key"
      @click="select(key)">
      {{ optionMap[key] }}
    </my-radio-button>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { ref, computed, watch } from 'vue';
import MyRadioButton from './MyRadioButton.vue';

const props = defineProps({
  optionMap: { type: Object, required: true, default: () => ({}) },
  colorMap: { type: Object, required: true, default: () => ({}) },
  modelValue: { type: String, default: '' }
});
const emit = defineEmits(['update:modelValue']);

const keys = computed(() => Object.keys(props.optionMap));
const current = ref(props.modelValue || keys.value[0] || ''); // 本地状态用于兼容受控/非受控

watch(
  () => props.modelValue,
  (val) => { if (val !== current.value) current.value = val; }
);

function select(key) {
  // 避免重复触发 update
  if (current.value !== key) {
    current.value = key;
    emit('update:modelValue', key);
  }
}
</script>
